var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShoppingCart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.85234 4.30992C2.92145 2.04021 4.52952 0.0999756 6.65004 0.0999756C8.77056 0.0999756 10.3786 2.04021 10.4477 4.30992L10.4507 4.40687H12.5929C12.928 4.40687 13.2001 4.70349 13.2001 5.06968V17.2371C13.2001 17.6033 12.928 17.8999 12.5929 17.8999H0.70724C0.372159 17.8999 0.100098 17.6033 0.100098 17.2371V5.06968C0.100098 4.70349 0.372159 4.40687 0.70724 4.40687H2.84939L2.85234 4.30992ZM6.65004 1.30884C5.3116 1.30884 4.09917 2.56658 4.02967 4.30288L4.02551 4.40687H9.27457L9.27041 4.30288C9.20091 2.56658 7.98847 1.30884 6.65004 1.30884ZM11.9858 5.73248H1.31438V16.5743H11.9858V5.73248Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingCart);
export default __webpack_public_path__ + "static/media/shopping_cart.a2408d40e1f5f407fe867bbe8921e6db.svg";
export { ForwardRef as ReactComponent };